export function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function normalizeRouteParams(
  raw: Record<string, string> | undefined,
): Record<string, string> {
  if (!raw) return {};

  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(raw)) {
    if (value !== undefined) out[key] = value;
  }
  return out;
}

export function normalizeFormPayload(
  payload: Record<string, unknown> | undefined,
): Record<string, unknown> {
  if (!payload || typeof payload !== "object") return {};

  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(payload)) {
    if (value == null) {
      out[key] = value;
      continue;
    }
    if (typeof File !== "undefined" && value instanceof File) {
      out[key] = value.name;
      continue;
    }
    out[key] = value;
  }
  return out;
}

export function toRecord(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  return { ...(value as Record<string, unknown>) };
}

export function safeParseJsonObject(raw: string | null): Record<string, unknown> {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return isPlainObject(parsed) ? parsed : {};
  } catch {
    return {};
  }
}